import BenefitIntegrationPersonData from "../Benefit/BenefitIntegrationPersonData";

export default interface RequestBenefitDetails {
  id: number;
  requestBenefitId: number;
  oib: string;
  firstName: string;
  lastName: string;
  relationshipId?: number;
  relationshipName: string;
  fetchedIntegrationData: boolean;
  integrationData?: BenefitIntegrationPersonData;
}

export const requestBenefitDetailsInitial: RequestBenefitDetails = {
  id: 1,
  requestBenefitId: 0,
  oib: "",
  firstName: "",
  lastName: "",
  relationshipId: undefined,
  relationshipName: "",
  fetchedIntegrationData: false,
  integrationData: undefined,
};
